<template>
    <el-table
        stripe
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="headCellStyle"
        :height="tableHeight"
        @selection-change="handleSelectionChange"
    >
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="recordDate" :label="$t('integration.record_date')" show-overflow-tooltip>
            <template #default="{ row }">
                <i v-icon="['approvalStatusConvert', row.approve]"></i>
                <span>{{ row.recordDate }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('public.status')" show-overflow-tooltip>
            <template #default="{ row }">
                <i :class="statusFn(row.status)"></i>
            </template>
        </el-table-column>
        <el-table-column prop="current" :label="$t('public.amount')" show-overflow-tooltip>
            <template #default="{ row }">
                <span>{{ row.current }}/{{ row.cnt }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="approveName" :label="$t('integration.approver')" show-overflow-tooltip />
        <el-table-column prop="updateTime" :label="$t('integration.approval_time')" show-overflow-tooltip>
            <template #default="{ row }">
                <span>{{ $timetransition(row['updateTime']) }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="Operate" :label="$t('tableTitle.Operating')" width="140px" align="center">
            <template #default="{ row }">
                <el-button type="text" size="small" icon="el-icon-check" :title="$t('integration.approved')" @click="handle('approveFn', row)" v-if="row.approve === null"></el-button>
                <el-button type="text" size="small" icon="el-icon-close" :title="$t('integration.approval_rejected')" @click="handle('noApproveFn', row)" v-if="row.approve === null"></el-button>
                <el-button type="text" size="small" icon="el-icon-tickets" :title="$t('integration.record_details')" @click="handle('detailFn', row)"></el-button>
                <el-button type="text" size="small" icon="el-icon-delete" :title="$t('integration.delete_record_point')" @click="handle('delRowFn', row)"></el-button>

                <!-- v-has="item.vHas" -->
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
    props: ['tableData', 'loading'],
    data() {
        return {
            tableHeight: '500px'
        };
    },

    methods: {
        handle(method, row) {
            this.$emit(method, row);
        },
        statusFn(status) {
            return status === 1 ? 'el-icon-check' : '';
        },
        iconFn(approve) {
            return approve === 1 ? 'el-icon-circle-check green' : approve === 0 ? 'el-icon-circle-close red' : 'el-icon-circle-close grey';
        },
        handleSelectionChange(arg) {
            this.$emit('choozeTable', arg);
        }
    }
};
</script>

<style lang="scss" scoped></style>
